import {
  USER_TYPE_PAGE,
  USER_TYPE_USER,
  ROLE_ADMIN,
  ROLE_MODERATOR,
  ROLE_ROOT,
} from "../../utils/index";
import * as jwtService from "../../services/jwt.service";

const resolveRole = () => {
  const jwtToken = jwtService.get();
  if (!jwtToken) {
    return null;
  }
  if (jwtToken.isRoot === true) {
    return ROLE_ROOT;
  }
  if (jwtToken.isAdmin === true) {
    return ROLE_ADMIN;
  }
  return ROLE_MODERATOR;
};

const MENU_DEFINITION = [
  {
    icon: "icon-home",
    label: "Tableau de bord",
    to: "/",
    root: true,
    admin: true,
    moderator: true,
  },

  {
    icon: "icon-pie-chart",
    label: "Statistiques",
    content: [
      {
        label: "Utilisateurs actifs",
        to: "/stats/users-active",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Badges utilisateurs",
        to: "/stats/users-badges",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 2,
    root: true,
    admin: true,
    moderator: true,
  },

  {
    icon: "icon-paper-clip",
    label: process.env.REACT_APP_SOCIAL_HUB
      ? process.env.REACT_APP_APP_NAME || "Social Hub"
      : "MyOpinion",
    content: [
      {
        label: "Utilisateurs",
        to: `/users?user_type=${USER_TYPE_USER}`,
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Pages",
        to: `/users?user_type=${USER_TYPE_PAGE}`,
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB ? "Posts" : "Opinions",
        to: "/opinions",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB
          ? "Posts (boostés)"
          : "Opinions (boostées)",
        to: "/opinions?boosted=1",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Challenges",
        to: "/challenges",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Lives",
        to: "/lives",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Evénements",
        to: "/events",
        root: true,
        admin: true,
        moderator: true,
        socialhub_only: true,
      },
      {
        label: "Commentaires",
        to: "/comments",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: process.env.REACT_APP_SOCIAL_HUB ? "Groupes" : "Agoras",
        to: "/agoras",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Reports",
        to: "/reports",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Awards",
        to: "/awards",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
      {
        label: "Verifications",
        to: "/verifications",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
      {
        label: "Abonnements",
        to: "/subscriptions",
        root: true,
        admin: true,
        moderator: true,
        myopinion_only: true,
      },
    ],
    contentIndex: 3,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-credit-card",
    label: "Monétisation",
    content: [
      {
        label: "Statistique",
        to: "/payments/statistics",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des portefeuilles",
        to: "/wallets",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des comptes monétisés",
        to: "/payments/cashout",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Liste des retraits",
        to: "/payments",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 6,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-users",
    label: "Ressources humaines",
    content: [
      {
        label: "Soldes de conges",
        to: "/hr/holidays_balance",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 5,
    root: true,
    admin: true,
    moderator: true,
    socialhub_only: true,
  },
  {
    icon: "icon-layers",
    label: "Gestion de paiement",
    content: [
      {
        label: "Vue d'ensemble",
        to: "/payment-settings",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Pays et frais",
        to: "/payment-countries",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Méthodes de paiement",
        to: "/payment-methods",
        root: true,
        admin: true,
        moderator: true,
      },
      {
        label: "Providers",
        to: "/payment-providers",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 5.5,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-lock",
    label: "Securité",
    content: [
      {
        label: "Moderateurs",
        to: "/moderateurs",
        root: true,
        admin: false,
        moderator: false,
      },
      {
        label: "Hubs",
        to: "/hubs",
        root: true,
        admin: true,
        moderator: false,
        myopinion_only: true,
      },
      {
        label: "Autorisations",
        to: "/authorizations",
        root: true,
        admin: true,
        moderator: false,
        socialhub_only: true,
      },
      {
        label: "Demandes d'autorisations",
        to: "/authorization-requests",
        root: true,
        admin: true,
        moderator: false,
        socialhub_only: true,
      },
      {
        label: "Rapport d'activités",
        to: "/logs",
        root: true,
        admin: true,
        moderator: true,
      },
    ],
    contentIndex: 8,
    root: true,
    admin: true,
    moderator: true,
  },
  {
    icon: "icon-settings",
    label: "Paramètres",
    to: "/settings",
    root: true,
    admin: true,
    moderator: false,
  },
];

const itemVisibleForRole = (obj, role) => {
  switch (role) {
    case ROLE_ROOT:
      return obj.root === true;
    case ROLE_ADMIN:
      return obj.admin === true;
    case ROLE_MODERATOR:
      return obj.moderator === true;
    default:
      return obj.moderator === true;
  }
};

/**
 * Construit le menu à partir du JWT actuel (localStorage).
 * Ne pas figer le menu au chargement du module : au premier import le token peut être absent
 * et des entrées du menu peuvent disparaître.
 */
const buildMetisMenu = () => {
  const role = resolveRole();

  const formatSubMenu = (index, baseMenu = []) => {
    let startIndex = Number.parseFloat(index);

    return baseMenu
      .filter((obj) => {
        if (obj.myopinion_only && process.env.REACT_APP_SOCIAL_HUB) return false;
        if (obj.socialhub_only && !process.env.REACT_APP_SOCIAL_HUB) return false;
        return itemVisibleForRole(obj, role);
      })
      .map((obj) => {
        const { root, admin, moderator, ...rest } = obj;
        startIndex += 0.1;
        return {
          id: startIndex.toString(),
          ...rest,
        };
      });
  };

  let startIndex = 0;

  return MENU_DEFINITION.filter((obj) => {
    if (obj.myopinion_only && process.env.REACT_APP_SOCIAL_HUB) return false;
    if (obj.socialhub_only && !process.env.REACT_APP_SOCIAL_HUB) return false;
    return itemVisibleForRole(obj, role);
  }).map((obj) => {
    const { root, admin, moderator, socialhub, content, contentIndex, ...rest } = obj;
    startIndex += 1;
    const out = {
      id: startIndex.toString(),
      ...rest,
    };
    if (Array.isArray(content) && contentIndex != null) {
      out.content = formatSubMenu(contentIndex, content);
    }
    return out;
  });
};

export default buildMetisMenu;
